// extracted by mini-css-extract-plugin
export var wrapper = "video-module--wrapper--62c47";